import { requestAuthorized } from './index';
import { webApiEndpoint } from '../clientConfig';

export const fetchPowerBiEmbeddedConfig = () =>
  requestAuthorized({
    url: `${webApiEndpoint}/api/dashboard/powerbiembed`,
    method: 'get',
  }).then((response) => response.data);
